import React from "react";
import moment from "moment";
import Resizer from "react-image-file-resizer";
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "https://api2.tubayo.com/";
export const APIURL = `${BASE_URL}api/v2/`;

const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      400,
      400,
      "PNG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64",
    );
  });

export const compressedFile = async (file) => {
  const dataURI = await resizeFile(file);
  const splitDataURI = dataURI.split(",");
  const byteString =
    splitDataURI[0].indexOf("base64") >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
  return new Blob([ia], { type: mimeString });
};

export const currency_format = (amount, decimal = ".", thousands = ",") => {
  let decimalCount = 0;
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)),
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;
    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {}
};

export const longDateFormat = (date) => {
  const newDate = date && date.replace(/["']/g, "");
  var d = new Date(newDate);
  return (
    ("0" + d.getDate()).slice(-2) +
    "/" +
    ("0" + (d.getMonth() + 1)).slice(-2) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    " " +
    (d.getHours() >= 12 ? "pm" : "am")
  );
};

const formatDate = (date) => new Date(date).toDateString();
// moment(date && date.split("T")[0], "YYYY-MM-DD").format("DD-MMM");

export const dataURItoBlob = (dataurl, filename) => {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  let croppedImage = new File([u8arr], filename, { type: mime });
  return croppedImage;
};

export const formate_csv_data = (payload) => {
  let userName, email, phone_no, country;
  let data = [];

  for (let i = 0; i < payload.length; i++) {
    userName = payload[i].username;
    email = payload[i].email;
    phone_no = payload[i].phone_number;
    country = payload[i].country;

    data = [
      ...data,
      {
        Username: userName,
        PhoneNumber: phone_no,
        Email: email,
        Country: country,
      },
    ];
  }

  return data;
};

export const generateCSV_hostData = (hosts) => {
  let data = [];
  for (let i = 0; i < hosts.length; i++) {
    data = [
      ...data,
      {
        First_Name: hosts[i].firstName,
        Last_Name: hosts[i].lastName,
        Email: hosts[i].email,
        Telephone: hosts[i].phoneNumber,
        hasListings: hosts[i].hasListings ? true : false,
      },
    ];
  }
  return data;
};

export const generateCSV_postData = (posts) => {
  const data = posts.map((post) => ({
    title: post.postTitle,
    body: post.postBody,
    author: post.author,
  }));
  return data;
};

export const generateCSV_referralData = (referrals) => {
  let data = [];
  for (let i = 0; i < referrals.length; i++) {
    data = [
      ...data,
      {
        Code: referrals[i].code || referrals[i].referral,
        Referred: referrals[i].referred,
        Email: referrals[i].email,
        Telephone: referrals[i].phoneNumber,
      },
    ];
  }
  return data;
};

export const generateCSV_event_bookings = (booking, booked) => {
  let data = [];
  for (let i = 0; i < booking.length; i++) {
    data = [
      ...data,
      {
        Name: `${booking[i].firstName} ${booking[i].lastName}`,
        Email: booking[i].email,
        Telephone: booking[i].phoneNumber,
        Booked: booked,
        Ticket: booking[i].ticket,
        Guests: booking[i].numberOfTickets,
        Amount: booking[i].amountPaid,
        ListingTitle: booking[i].eventPaidFor,
      },
    ];
  }
  return data;
};

export const generateCSV_bookings = (booking, booked) => {
  let data = [];
  for (let i = 0; i < booking.length; i++) {
    data = [
      ...data,
      {
        Name: `${booking[i].firstName} ${booking[i].lastName}`,
        Email: booking[i].email,
        Telephone: booking[i].phoneNumber,
        Booked: booked,
        ListingTitle: `${
          booking[i].experiencePaidFor ||
          booking[i].homePaidFor ||
          booking[i].eventPaidFor
        }`,
      },
    ];
  }
  return data;
};

export const refactorUserObj = (users) => {
  let newUserData = [];
  newUserData = users.map((user, idx) => {
    let userName,
      email,
      country,
      phone_no,
      date = new Date(user.create_date).toDateString();
    userName = user.username;
    email = user.email;
    phone_no = user.phone_number || "";
    country = user.country;

    return { date, userName, email, phone_no, country, id: user.id };
  });
  return newUserData;
};

export const refactorWishListObj = (wishLists) => {
  let newUserData = [];
  newUserData = wishLists.map((wishList, idx) => {
    let userName,
      email,
      country,
      phone_no,
      // no = wishLists.length - idx,
      userId = wishList.user.id;
    userName = wishList.user.username;
    email = wishList.user.email;
    phone_no = wishList.user.phone_number || "";
    country = wishList.user.country;

    const userWishList = wishLists.reduce((acc, val) => {
      acc = val.user.id === userId ? acc + 1 : acc + 0;
      return acc;
    }, 0);

    return {
      userWishList,
      userName,
      email,
      phone_no,
      country,
      id: userId,
    };
  });

  const dataIdArray = newUserData.map((data) => data._id);
  const uniqeDataSet = new Set(dataIdArray);
  const uniqeData = [...uniqeDataSet];
  const transformedData = newUserData.reduce((accumlator, data) => {
    accumlator[data._id] = data;
    return accumlator;
  }, {});
  const newDataCollection = uniqeData.map((dataId) => transformedData[dataId]);
  return newDataCollection;
};

const filter_listings = (listingsArray) => {
  let approved_listings = [],
    pending_listing = [],
    app_count = 0,
    pend_count = 0;
  listingsArray.forEach((listing) => {
    if (listing.approved) {
      app_count = ++app_count;
      approved_listings = [...approved_listings, { no: app_count, ...listing }];
    } else {
      pend_count = ++pend_count;
      pending_listing = [...pending_listing, { no: pend_count, ...listing }];
    }
  });

  return {
    approved_listings,
    pending_listing,
    total_listings: listingsArray.length,
  };
};

export const refactorExperienceObj = (experiences, page) => {
  let newExpData = [];
  let _page = page - 1;
  _page = _page * 50;
  newExpData = experiences.map((experience, idx) => {
    let no = idx + 1 + _page;

    const {
      title,
      district,
      country,
      price,
      currency,
      experience_category,
      approved,
      hasOffer,
      id,
      created_at,
    } = experience;
    return {
      no,
      createdAt: formatDate(created_at),
      title,
      country,
      district,
      experience_category,
      createdDate: `${currency} ${price}`,
      approved,
      hasOffer,
      id,
    };
  });

  return filter_listings(newExpData);
};

export const refactorEventObj = (events) => {
  let newExpData = [];
  newExpData = events.map((event, idx) => {
    const {
      event_name,
      address,
      country,
      start_date,
      approved,
      start_time,
      id,
      created_at,
    } = event;
    return {
      // no,
      createdAt: formatDate(created_at),
      event_name,
      country,
      address,
      start_date: formatDate(start_date),
      start_time,
      approved,
      id,
    };
  });

  return filter_listings(newExpData);
};

export const refactorHomesObj = (homes, page) => {
  let newHomesData = [];
  let _page = page - 1;
  _page = _page * 50;
  newHomesData = homes.map((home, idx) => {
    let no = idx + 1 + _page;
    const {
      title,
      city,
      country,
      price,
      currency,
      approved,
      hasOffer,
      home_type,
      id,
      created_at,
    } = home;
    return {
      no,
      createDate: formatDate(created_at),
      title,
      home_type,
      country,
      city,
      price: `${currency} ${price}`,
      approved,
      hasOffer,
      id,
    };
  });
  return filter_listings(newHomesData);
};

export const refactorHotelsObj = (hotels, page) => {
  let newHotelsData = [];
  let _page = page - 1;
  _page = _page * 50;
  newHotelsData = hotels.map((hotel, idx) => {
    let no = idx + 1 + _page;
    const { title, city, country, approved, place_type, id, created_at } =
      hotel;
    return {
      no,
      createdAt: formatDate(created_at),
      title,
      place_type,
      country,
      city,
      approved,
      id,
    };
  });
  return filter_listings(newHotelsData);
};

const filter_hosts = (hostsArray) => {
  let hasListings_hosts = [],
    noListings_hosts = [],
    has_count = 0,
    no_count = 0;
  hostsArray.forEach((host) => {
    if (host.hasListings) {
      has_count = ++has_count;
      hasListings_hosts = [...hasListings_hosts, { no: has_count, ...host }];
    } else {
      no_count = ++no_count;
      noListings_hosts = [...noListings_hosts, { no: no_count, ...host }];
    }
  });

  return {
    hasListings_hosts: hasListings_hosts || [],
    noListings_hosts: noListings_hosts || [],
    hostsArray,
    total_hosts: hostsArray.length,
  };
};

export const refactorHostsObj = (hosts) => {
  let newHostsData = [];
  newHostsData = hosts.map((host, idx) => {
    let no = hosts.length - idx;
    const { first_name, last_name, username, country, phone_number } =
      host.user;
    return {
      no,
      firstName: first_name,
      lastName: last_name,
      userName: username,
      phone_number,
      country,

      id: host.id,
    };
  });
  return filter_hosts(newHostsData);
};

export const refactorPostsObj = (Posts) => {
  let newPostsData = [];
  newPostsData = Posts.map((Post, idx) => {
    let no = Posts.length - idx;
    const { postTitle, postBody, author, createdDate, _id, postImage } = Post;
    return {
      no,
      imgComp: (
        <img
          src={postImage}
          alt="slide"
          style={{ width: "15rem", height: "7rem" }}
        />
      ),
      postTitle,
      postBody: `${postBody.slice(0, 250)}...`,
      author,
      createDate: longDateFormat(createdDate),
      _id,
    };
  });
  return newPostsData;
};

export const refactorBookingObj = (bookings) => {
  let newBookingData = [];
  newBookingData = bookings.map((booking, idx) => {
    let no = bookings.length - idx;
    const title =
      booking.experience_title || booking.home_title || booking.event_name;
    const bookingDate = booking.check_in_date;
    const { names, phone_number, host, id } = booking;

    return {
      no,
      bookingDate: formatDate(bookingDate),
      title,
      names,
      phone_number,
      hostName: `${host?.username}`,
      hostTel: host?.phone_number,
      id,
    };
  });
  return newBookingData;
};

export const refactorDestinationObj = (destinations) => {
  let newDestData = [];
  newDestData = destinations.map((destination, idx) => {
    let no = ++idx;
    const { imgUrl, destinationTitle, destinationCountry, _id } = destination;
    return {
      no,
      imgComp: (
        <img
          src={imgUrl}
          alt="slide"
          style={{ width: "15rem", height: "7rem" }}
        />
      ),
      destinationTitle,
      destinationCountry,
      _id,
    };
  });
  return newDestData;
};

export const refactorReviewObj = (reviews) => {
  let newReviewData = [];
  newReviewData = reviews.map((review, idx) => {
    let no = reviews.length - idx;
    const { rating, comment, _id } = review;
    return {
      no,
      rating,
      comment: comment.length > 100 ? comment.slice(0, 100) : comment,
      _id,
    };
  });
  return newReviewData;
};

export const refactorNotificationsObj = (notifications) => {
  let newNotificationData = [];
  newNotificationData = notifications.map((notification, idx) => {
    let no = ++idx;
    const { notificationTitle, notificationBody, sentAt, _id } = notification;
    return {
      no,
      notificationTitle,
      notificationBody,
      sentAt: formatDate(sentAt),
      _id,
    };
  });
  return newNotificationData;
};

export const refactorShopCatsObj = (categories) => {
  let newCategoryData = [];
  newCategoryData = categories.map((category, idx) => {
    let no = ++idx;
    const { name, sub_categories, id } = category;
    return {
      no,
      name,
      subCategoies: sub_categories && sub_categories.length,
      id,
    };
  });
  return newCategoryData;
};

export const refactorDiscountcodeObj = (discountCodes) => {
  let newDiscountCodeData = [];
  newDiscountCodeData = discountCodes.map((discountCode, idx) => {
    let no = ++idx;
    const { code, percentageDiscount, maximumLimit, isActive, _id } =
      discountCode;
    return { no, code, percentageDiscount, maximumLimit, isActive, _id };
  });
  return newDiscountCodeData;
};

export const refactorReferralsObj = (referrals) => {
  let newReferralData = [];
  newReferralData = referrals.map((referral, idx) => {
    let no = referrals.length - idx;
    const { code, referred, email, phoneNumber, createdAt } = referral;
    return {
      no,
      code,
      referred,
      email,
      phoneNumber,
      createdAt: formatDate(createdAt),
    };
  });
  return newReferralData;
};

export const refactorInquiryObj = (inquiries) => {
  let newInquiries = [];
  newInquiries = inquiries.map((inq, idx) => {
    let no = inquiries.length - idx;
    const {
      name,
      phoneNumber,
      email,
      inquiry,
      handler,
      createdAt,
      _id,
      status,
    } = inq;
    let date = formatDate(createdAt);
    return {
      No: no,
      Date: date,
      Names: name,
      Tel: phoneNumber,
      Email: email,
      Inquiry: inquiry,
      Handler: handler,
      Status: status,
      _id,
    };
  });
  return newInquiries;
};

export const refactorCustomerObj = (Customers) => {
  let newCustomers = [];
  newCustomers = Customers.map((customer, idx) => {
    let no = Customers.length - idx;
    const { full_name, phone_number, email, listing_booked, listing_type, id } =
      customer;
    return {
      No: no,
      Listing: listing_booked,
      Type: listing_type,
      Names: full_name,
      Tel: phone_number,
      Email: email,
      id,
    };
  });
  return newCustomers;
};

export const refactorExpCashObj = (data) => {
  let newData = [];
  newData =
    data &&
    data.map((dataItem, idx) => {
      let no = data.length - idx;
      const {
        names,
        phoneNumber,
        email,
        host_names,
        host_phoneNumber,
        experienceBooked,
        number_of_people,
        amount_paid,
        checkin_date,
        createdAt,
        _id,
      } = dataItem;
      let date = formatDate(createdAt);
      return {
        no,
        date,
        names,
        phoneNumber,
        email,
        host_names,
        host_phoneNumber,
        experienceBooked,
        number_of_people,
        checkin_date: formatDate(checkin_date),
        amount_paid,
        _id,
      };
    });

  return newData;
};

export const refactorHomeCashObj = (data) => {
  let newData = [];
  newData =
    data &&
    data.map((dataItem, idx) => {
      let no = data.length - idx;
      const {
        host,
        home,
        firstName,
        lastName,
        phoneNumber,
        nightsToStay,
        checkInDate,
        numberOfGuests,
        createdAt,
        status,
        _id,
      } = dataItem;
      let date = formatDate(createdAt);

      return {
        no,
        date,
        names: `${firstName} ${lastName}`,
        phoneNumber,
        host_names: `${host?.firstName} ${host?.lastName}`,
        host_phoneNumber: host?.phoneNumber,
        homeBooked: home && home.homeTitle,
        nightsToStay,
        checkin_date: new Date(checkInDate).toDateString(),
        numberOfGuests,
        status,
        _id,
      };
    });

  return newData;
};

export const format_transactions_data = (transactions) => {
  let newData = [];
  newData =
    transactions &&
    transactions.map((transaction, idx) => {
      let no = transactions.length - idx;
      const {
        user_name,
        user_email,
        listing_name,
        currency,
        created_at,
        listing_type,
        phone_number,
        amount,
        id,
      } = transaction;
      let date = formatDate(created_at);
      return {
        no,
        user_name,
        user_email,
        phone_number,
        listing_name,
        listing_type,
        amount: `${currency} ${amount}`,
        // host_amount: 0,
        // date,
        id,
      };
    });
  return newData;
};

export const refactorShopObj = (shops, page) => {
  let newShopData = [];
  newShopData = shops.map((shop, idx) => {
    let no = idx + 1 + (page - 1) * 100;

    return {
      no,
      date: formatDate(shop.created_at),
      name: shop.name || "",
      country: shop.country || "",
      contact: shop.phone || "",
      email: shop.email || "",
      createdAt: formatDate(shop.created_at),
      approved: shop.is_active,
      id: shop.id,
    };
  });
  return filter_listings(newShopData);
};

export const refactorProductObj = (Products) => {
  let newProductData = [];
  newProductData = Products.map((Product, idx) => {
    // let no = Products.length - idx;

    return {
      // no,
      name: Product?.name || "",
      category: Product?.category?.name || "",
      brand: Product.brand || "",
      price: `${Product.currency} ${Product.price}`,
      store: Product.store?.name || "",
      approved: Product.store?.is_active,
      _id: Product.id,
    };
  });
  return filter_listings(newProductData);
};

export const RULES_LIST = [
  "No parties or events allowed.",
  "No smoking allowed.",
  "No pets allowed.",
  "Suitable for toddlers and children under 12.",
  "No unregistered guests allowed. ",
  "Please don’t eat or drink in the bedrooms.",
  "Please respect the noise curfew.",
  "Please turn off the AC when you go out.",
  "Please respect check-in and check-out times. ",
  "Please take extra care of your keys. Lost keys incur a replacement fee.",
  "Please take care of the furnishings. You have to pay for damages that exceed the security deposit.",
  "Please don’t rearrange the furniture.",
  "Please do your dishes.",
  "Please take the trash out before you leave.",
  "No illegal substances allowed on the premises.",
];

export const AMENITIES_LIST = [
  "Wifi",
  "Free parking",
  "A pool",
  "A jacuzzi",
  "A kitchen",
  "Air conditioning",
  "Heating",
  "A washer",
  "TV or cable",
  "Smoke alarm",
  "Carbon monoxide alarm",
  "Fire extinguisher",
  "First-aid kit",
  "Emergency plan and local numbers",
  "Toilet paper",
  "Soap for hands and body",
  "One towel per guest",
  "Linens for each bed",
  "One pillow per guest",
  "Cleaning supplies",
  "A pet-friendly space",
  "Step-free entryway",
  "Wide entrances",
  "Wide hallways",
  "Accessible bathroom",
  "Extra toilet paper, linens, and towels",
  "Basic toiletries like shampoo and conditioner",
  "Dish soap and cleaning supplies",
  "Dining basics like a coffee maker, cooking utensils, dishes, and silverware",
  "Wine glasses",
  "Basic cooking supplies like salt, pepper, and oil",
  "Coffee, tea",
  "Light breakfast or snacks",
  "Hangers",
  "Adapters and chargers",
  "Fast and reliable wifi",
  "Laptop-friendly workspace",
  "Good lighting",
  "Fully equipped kitchens",
  "Office supplies",
  "A crib and high chair",
  "A bathtub",
  "Air conditioning",
  "A washer and/or dryer",
  "Extra cleaning supplies",
  "Furniture covers",
  "Bowls for pet food and water",
  "Towels to wipe off paws at the door",
];

export const ROOM_TYPES = [
  "Single",
  "Double",
  "Triple",
  "Quadruple",
  "Suite",
  "Family",
  "Dormitory",
  "Studio",
  "Apartment",
  "Twin",
];

export const BED_TYPES = [
  "Single Bed",
  "Double Bed",
  "Queen Bed",
  "King Bed",
  "Sofa Bed",
  "Extra-large double bed",
  "Bunk Bed",
  "Futon Bed",
];
